module.exports = __webpack_public_path__ + "media/bgm.8035c6a0.mp3";